import React, { useState } from 'react'
import Header from "./common/header";
import Footer from "./common/footer";
import Slider from "./common/slider";

import "./App.css";
import './css/style.css';
import './css/bootstrap.css'


const BASE_URL = 'https://knowyourmilk-uat.smartmoo.com/traceability/service-04/dairy-tales/'
const API_KEY = 'TrAceAbiLITy@^)!'

const Data = () => {
  const [singleCode, setSingleCode] = useState('')
  const [singleLoading, setSingleLoading] = useState(false)
  const [singleError, setSingleError] = useState('')
  const [singleLogo, setSingleLogo] = useState('')
  const [singleStatus, setSingleStatus] = useState('')

  const [bulkInput, setBulkInput] = useState('')
  const [bulkLoading, setBulkLoading] = useState(false)
  const [bulkResults, setBulkResults] = useState([])

  const fetchSingle = async () => {
    const code = singleCode.trim()
    if (!code) {
      setSingleError('Please enter a batch code.')
      return
    }
    setSingleLoading(true)
    setSingleError('')
    setSingleLogo('')
    setSingleStatus('')
    try {
      const url = `${BASE_URL}${encodeURIComponent(code)}/brand`
      const res = await fetch(url, {
        method: 'GET',
        headers: { 'x-api-key': API_KEY }
      })
      setSingleStatus(`${res.status} ${res.statusText}`)
      const json = await res.json()
      const maybe = json && json.data && json.data.logo && json.data.logo.image
      if (json && json.statusCode === 200 && typeof maybe === 'string') {
        setSingleLogo(maybe)
      } else {
        setSingleError('No logo found or batch code is invalid.')
      }
    } catch (e) {
      setSingleError('Error fetching data. Check console.')
      // Intentionally log for debugging
      // eslint-disable-next-line no-console
      console.error('Single fetch error', e)
    } finally {
      setSingleLoading(false)
    }
  }

  const fetchMultiple = async () => {
    const codes = bulkInput.split(/[\,\n\r\t\s]+/).filter(Boolean)
    if (codes.length === 0) {
      setBulkResults([{ code: '', error: 'Please enter at least one batch code.' }])
      return
    }
    setBulkLoading(true)
    setBulkResults([])
    const results = []
    for (const codeRaw of codes) {
      const code = codeRaw.trim()
      try {
        const url = `${BASE_URL}${encodeURIComponent(code)}/brand`
        const res = await fetch(url, { method: 'GET', headers: { 'x-api-key': API_KEY } })
        const json = await res.json()
        const maybe = json && json.data && json.data.logo && json.data.logo.image
        if (json && json.statusCode === 200 && typeof maybe === 'string') {
          results.push({ code, logo: maybe })
        } else {
          results.push({ code, error: 'No logo found or batch code is invalid.' })
        }
      } catch (e) {
        results.push({ code, error: 'Error fetching brand logo. Check console.' })
        // eslint-disable-next-line no-console
        console.error(`Bulk fetch error for ${code}`, e)
      }
    }
    setBulkResults(results)
    setBulkLoading(false)
  }

  return (
    <div className="bg-light d-flex flex-column vh-100">
            <Header /> {/* Add Header here */}

            <Slider />
    <div style={{ padding: 16 }}>
      <div style={{ maxWidth: 920, margin: '0 auto' }}>
        <div style={{ textAlign: 'center', marginBottom: 16 }}>
          <h2 style={{ margin: 0 }}>Milk Traceability</h2>
          <p style={{ color: '#667085', marginTop: 6 }}>Search by batch code to view brand logo</p>
        </div>

        <div style={{
          background: '#fff',
          border: '1px solid #eef2f7',
          borderRadius: 12,
          boxShadow: '0 6px 18px rgba(16,24,40,0.06)',
          padding: 16,
          marginBottom: 16
        }}>
          <h3 style={{ marginTop: 0, marginBottom: 12 }}>Fetch Single Brand Logo</h3>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr auto', gap: 8 }}>
            <input
              type="text"
              value={singleCode}
              onChange={(e) => setSingleCode(e.target.value)}
              placeholder="Enter Batch Code (e.g. K1A25248)"
              style={{
                padding: '12px 14px',
                border: '1px solid #d0d5dd',
                borderRadius: 10,
                outline: 'none'
              }}
            />
            <button
              onClick={fetchSingle}
              disabled={singleLoading}
              style={{
                padding: '12px 16px',
                background: singleLoading ? '#93c5fd' : '#2563eb',
                color: '#fff',
                border: 'none',
                borderRadius: 10,
                cursor: singleLoading ? 'not-allowed' : 'pointer',
                // minWidth: 160
              }}
            >
              {singleLoading ? 'Loading…' : 'Enter'}
            </button>
          </div>
          {/* {singleStatus && !singleError && (
            <div style={{ color: '#475467', marginTop: 8, fontSize: 14 }}>Status: {singleStatus}</div>
          )} */}
          {singleError && (
            <div style={{
              color: '#b42318',
              background: '#ffefef',
              border: '1px solid #ffe1e1',
              borderRadius: 10,
              padding: '10px 12px',
              marginTop: 8
            }}>{singleError}</div>
          )}
          {singleLogo && (
            <div style={{ marginTop: 12, display: 'flex', justifyContent: 'center' }}>
              <img
                src={singleLogo}
                alt="Logo"
                style={{
                  width: '100%',
                  maxWidth: 340,
                  height: 'auto',
                  borderRadius: 12,
                  boxShadow: '0 8px 24px rgba(16,24,40,0.08)'
                }}
              />
            </div>
          )}
        </div>

        <div style={{
          background: '#fff',
          border: '1px solid #eef2f7',
          borderRadius: 12,
          boxShadow: '0 6px 18px rgba(16,24,40,0.06)',
          padding: 16
        }}>
          <h3 style={{ marginTop: 0, marginBottom: 12 }}>Fetch Multiple Brand Logos</h3>
          <textarea
            value={bulkInput}
            onChange={(e) => setBulkInput(e.target.value)}
            placeholder="Enter batch codes, separated by commas or new lines"
            style={{
              width: '100%',
              height: 100,
              padding: 12,
              boxSizing: 'border-box',
              border: '1px solid #d0d5dd',
              borderRadius: 10
            }}
          />
          <div style={{ marginTop: 8, display: 'flex', justifyContent: 'flex-end' }}>
            <button
              onClick={fetchMultiple}
              disabled={bulkLoading}
              style={{
                padding: '10px 14px',
                background: bulkLoading ? '#93c5fd' : '#2563eb',
                color: '#fff',
                border: 'none',
                borderRadius: 10,
                cursor: bulkLoading ? 'not-allowed' : 'pointer'
              }}
            >
              {bulkLoading ? 'Loading…' : 'Fetch Logos'}
            </button>
          </div>

          <div
            style={{
              marginTop: 16,
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))',
              gap: 12
            }}
          >
            {bulkResults.map((r, idx) => (
              <div
                key={`${r.code}-${idx}`}
                style={{
                  border: '1px solid #eef2f7',
                  borderRadius: 12,
                  padding: 12,
                  background: '#fff',
                  textAlign: 'center',
                  boxShadow: '0 3px 12px rgba(16,24,40,0.05)'
                }}
              >
                {r.code && (
                  <div style={{ fontWeight: 600, fontSize: 14, marginBottom: 8 }}>Batch: {r.code}</div>
                )}
                {r.logo ? (
                  <img
                    src={r.logo}
                    alt={`Logo for ${r.code}`}
                    style={{ width: '100%', height: 'auto', borderRadius: 10 }}
                  />
                ) : (
                  <div style={{ color: '#b42318', fontSize: 13 }}>{r.error}</div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
    <Footer />
    </div>
  )
}

export default Data
